<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>JWebMP Vert.x</h1>
					<p waBody="m" waText>Vert.x 5 HTTP connector &mdash; automatic page routing, reactive AJAX pipeline, CSS/JS endpoints, WebSocket broadcasting via event bus, user-agent detection, and call-scope integration. Registers HTTP routes for page rendering, CSS delivery, AJAX event handling, data components, and internal scripts &mdash; all inside the GuicedEE call-scope model.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Vert.x 5</wa-tag>
						<wa-tag pill variant="neutral">Guice 7</wa-tag>
						<wa-tag pill variant="neutral">Maven 4</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp:jwebmp-vertx</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.vertx</p>
					<p waBody="s" waText>Built on: Eclipse Vert.x 5</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_124" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_125" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>COMPONENTS</div>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JWebMPVertxServlet</h4>
								<p waBody="s" waColorText="quiet" waText>Main Vert.x route handler for page rendering</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.vertx</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JWebMPAjaxServlet</h4>
								<p waBody="s" waColorText="quiet" waText>AJAX event handler at /jwajax</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.vertx</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JWebMPDataServlet</h4>
								<p waBody="s" waColorText="quiet" waText>Data component handler at /jwdata</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.vertx</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JWebMPCSSServlet</h4>
								<p waBody="s" waColorText="quiet" waText>CSS endpoint at /jwcss</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.vertx</div>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>JWebMPScriptServlet</h4>
								<p waBody="s" waColorText="quiet" waText>Site-loader script handler</p>
								<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>com.jwebmp.vertx</div>
							</div>
						</wa-card>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Automatic page routing &mdash; &#64;PageConfiguration classes discovered at startup and served as Vert.x routes</p>
					<p waBody="s" waColorText="quiet" waText>Reactive AJAX pipeline &mdash; request, deserialize, intercept, fireEvent&#40;&#41;, JSON response with 10s timeout</p>
					<p waBody="s" waColorText="quiet" waText>Data component servlet &mdash; serves IDataComponent.renderData&#40;&#41; as JSON</p>
					<p waBody="s" waColorText="quiet" waText>CSS endpoint &mdash; renders page-level CSS on demand at /jwcss</p>
					<p waBody="s" waColorText="quiet" waText>Site-loader script &mdash; template-driven JS bootstrap with server address, page class, user-agent placeholders</p>
					<p waBody="s" waColorText="quiet" waText>WebSocket broadcasting &mdash; IGuicedWebSocket bridged to Vert.x event bus &#40;direct or STOMP prefix&#41;</p>
					<p waBody="s" waColorText="quiet" waText>User-agent detection &mdash; ReadableUserAgent per call-scope via UADetector</p>
					<p waBody="s" waColorText="quiet" waText>Call-scope integration &mdash; every handler enters CallScope with RoutingContext, request, response, streamId</p>
					<p waBody="s" waColorText="quiet" waText>Jackson configuration &mdash; DatabindCodec aligned with GuicedEE JSON conventions</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Page Route Configuration</h4>
						<p waBody="s" waColorText="quiet" waText>Define a page that is automatically served by Vert.x.</p>
						<markdown [data]="mdContent_126" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Start the Server</h4>
						<p waBody="s" waColorText="quiet" waText>Bootstrap the Vert.x server with Guice.</p>
						<markdown [data]="mdContent_127" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_128" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceModule</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Registers Vert.x HTTP server, route handlers, and call-scope bindings</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">VertxHttpServerConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Configures Vert.x HttpServerOptions &mdash; port, SSL, compression, etc.</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">VertxRouterConfigurator</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Extension point for additional Vert.x route registration</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
						<wa-tag pill variant="success">provides VertxHttpServerConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>HTTP&#95;PORT</h4>
							<wa-tag pill variant="neutral">int</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Vert.x HTTP server port</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: 6500</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>AJAX&#95;TIMEOUT</h4>
							<wa-tag pill variant="neutral">int</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AJAX request timeout in milliseconds</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: 10000</div>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://vertx.io/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/VertX</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>